package com.snakesworld.game.di

import com.snakesworld.game.audio.SoundManager
import com.snakesworld.game.audio.createPlatformSoundManager
import com.snakesworld.game.network.MultiplayerRepository
import com.snakesworld.game.repository.LoggerRepository
import com.snakesworld.game.repository.LoggerRepositoryImpl
import com.snakesworld.game.network.createDefaultMultiplayerRepository
import com.snakesworld.game.viewmodel.AuthViewModel
import com.snakesworld.game.viewmodel.ConnectingViewModel
import com.snakesworld.game.viewmodel.GameViewModel
import com.snakesworld.game.viewmodel.LeaderboardViewModel
import com.snakesworld.game.viewmodel.MenuViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {
    single<LoggerRepository> { LoggerRepositoryImpl() }
    single<SoundManager> { createPlatformSoundManager() }
    single<MultiplayerRepository> { createDefaultMultiplayerRepository() }

    viewModel { AuthViewModel(get()) }
    viewModel { MenuViewModel(get()) }
    viewModel { ConnectingViewModel(get()) }
    viewModel { GameViewModel(get(), get()) }
    viewModel { LeaderboardViewModel(get()) }
}
